


export class GameModeOptions {
    classic_default_game_duration: number = 60;
    race_default_rush_words: number = 20;
    
    constructor(gameOptions: Array<any> | undefined = undefined) {
        if (!gameOptions) {
            return;
        }
        
        gameOptions.forEach((gameOption) => {
            const parsedValue = parseInt(gameOption["value"]);
            
            switch (gameOption["name"]) {
                case "DEFAULT_GAME_DURATION":
                    this.classic_default_game_duration = parsedValue;
                    break;
                case "DEFAULT_RUSH_WORDS":
                    this.race_default_rush_words = parsedValue;
                    break;
            }
        });
    }
}
